"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spaHeaderFallbackCss = void 0;
exports.spaHeaderFallbackCss = `
.SpaHeaderFallback {
  width: 100%;
  background: #1c49c2;
}

.SpaHeaderFallback__search-form {
  background: #fff;
  border-radius: 5px;
  margin-bottom: 0;
  margin-left: 17px;
  margin-right: 17px;
  position: relative;
  height: 35px;
  width: 100%;
  max-width: 700px;
  font-size: 10px;
}

.SpaHeaderFallback__search-input {
  height: 100%;
  width: 100%;
  font-size: 16px;
  border: none;
  background: transparent;
  padding: 0 40px 0 10px;
  appearance: none;
}

.SpaHeaderFallback__submit-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 0.4rem;
  top: 0.4rem;
  bottom: 0.4rem;

  display: flex;
  align-items: center;
}

.SpaHeaderFallback__submit-button svg {
  color: #1c49c2;
  height: 24px;
  width: 24px;
}

.SpaHeaderFallback__pull-left {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

.SpaHeaderFallback__logo-link {
  display: flex;
  align-items: center;
}

.SpaHeaderFallback__cart-icon {
  display: flex;
  align-items: center;
  height: 100%;
  color: #fff;
}

.SpaHeaderFallback__container {
  display: flex;
  align-items: center;
  height: 50px;
  margin: auto;
  min-width: 750px;
  max-width: 1400px;
  padding: 0 20px;
  transition: width 0.2s ease-out;
}

.SpaHeaderFallback__cart-link--mobile {
  display: none;
}

.chewy-logo {
  fill: #fff;
}

@media (min-width: 1400px) {
  .SpaHeaderFallback__container {
    padding: 0 60px;
  }
}

@media (min-width: 1250px) and (max-width: 1399px) {
  .SpaHeaderFallback__container {
    padding: 0 40px;
  }
}

@media (max-width: 969px) {
  .SpaHeaderFallback__container {
    min-width: 0;
    padding: 0 48px;
  }
}

@media (max-width: 749px) {
  .SpaHeaderFallback__container {
    height: auto;
    padding: 10px 48px;
    min-width: 0;
  }

  .SpaHeaderFallback__pull-left {
    flex-wrap: wrap;
    justify-content: center;
  }

  .SpaHeaderFallback__search-form {
    margin: 8px 0 0;
  }

  .SpaHeaderFallback__logo-link {
    flex: 0 1 auto;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .SpaHeaderFallback__cart-link--mobile {
    display: flex;
    justify-content: flex-end;
  }

  .SpaHeaderFallback__cart-link {
    display: none;
  }

  .SpaHeaderFallback__top-level {
    position: relative;
    height: 4rem;
    align-items: center;
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  .chewy-logo {
    height: 28px;
    width: 94px;
  }
}`;
//# sourceMappingURL=spa-header-css-fallback.js.map